import React from "react";
import styles from "./SelectDevices.module.scss";
import { Panel } from "../../Panel/Panel";
import {
  DataTable,
  DataTableHeaders,
  DataTableRow,
} from "@yoti/ui-kit-components-react/data-table";
import { Checkbox } from "@yoti/ui-kit-components-react/checkbox";
import { Loading } from "@yoti/ui-kit-components-react/loading";

const includesElement = (data, id) => data.some((element) => element.id === id);

const addElement = (data, element) => [...data, element];

const removeElement = (data, id) => data.filter((element) => element.id !== id);

export const SelectDevices = ({
  title,
  subtitle,
  data,
  selectedDevices,
  onChange,
  disabled,
}) => {
  const handleCheckboxChange = (element) => {
    const newSelectedDevices = includesElement(selectedDevices, element.id)
      ? removeElement(selectedDevices, element.id)
      : addElement(selectedDevices, element);
    onChange(newSelectedDevices);
  };

  const getTableRows = () =>
    data.map((element, index) => {
      const { id, label } = element;
      if (element instanceof TypeError) {
        return;
      }
      return (
        <DataTableRow key={`${id}_${index}`}>
          <td>{label}</td>
          <td>
            <Checkbox
              checked={includesElement(selectedDevices, id)}
              onChange={() => handleCheckboxChange(element)}
              id={`${id}`}
              disabled={disabled}
            />
          </td>
        </DataTableRow>
      );
    });

  if (!data.length) {
    return <Loading />;
  }

  return (
    <div className={styles.root}>
      <Panel>
        <div className={styles.text}>
          <h3>{title}</h3>
          {subtitle}
        </div>
        <DataTable>
          <DataTableHeaders>
            <th>Device name</th>
            <th>Share</th>
          </DataTableHeaders>
          {getTableRows()}
        </DataTable>
        <br />
      </Panel>
    </div>
  );
};
